export default {
	methods: {
		//generic function to fetch a model, and stick it into a $store location (if no $store location defined, uses modelName with 's' on end)
		fetchModel(modelName,storeLocation,params) {
			let vm = this

			return new Promise((resolve,reject) => {

				vm.getJSON(modelName+"/get",params,true).then(response => {

					if (!storeLocation) {
						let defaultStoreLocation = modelName.charAt(0).toLowerCase() + modelName.substr(1)+"s"

						vm.$store[defaultStoreLocation] = response.data
					}
					else
						vm.$store[storeLocation] = response.data

					resolve(response)
				})
			})
		},
		fetchEquipment(filters) {
			let vm = this

			return new Promise((resolve,reject) => {

				let paramFilters = [
					['archived', 0]
				]

				if (filters)
					paramFilters = paramFilters.concat(filters)

				let params = {
					include: ["EquipmentType"],
					filters: paramFilters
				}

				vm.getJSON("Equipment/get",params).then(response => {
					vm.$store.equipments = response.data

					resolve(response)
				})
			})
		},
		fetchEquipmentTypes(params) {
			let vm = this

			return new Promise((resolve,reject) => {

				if (!params)
					params = {}

				vm.getJSON("EquipmentType/get",params).then(response => {

					vm.$store.equipmentTypes = response.data

					resolve(response)
				})
			})
		},
		fetchCustomers(nameOnly,spinner) {
			let vm = this

			if (spinner)
				vm.spinner(true)

			return new Promise((resolve, reject) => {

				let filters = [
					["is_customer",1]
				]

				let params = {
					filters: filters,
				}

				if (nameOnly)
					params.fields = ["id","slug","name"]

				vm.getJSON("Contact/get",params).then(response => {
					vm.$set(vm.$store,"customers",response.data)
					vm.$set(vm.$store,"customerOptions",vm.optionify(response.data,"name"))

					if (spinner)
						vm.spinner(false)

					resolve(response)
				})
			})
		},
		fetchJobs(include,filters,fields,page,custom_page_limit) {
			let vm = this

			return new Promise((resolve,reject) => {

				let params = {}

				if (include)
					params.include = include

				if (filters)
					params.filters = filters
				else {
					params.filters = [
						["archived",0]
					]
				}

				if (page)
					params.page = page

				if (fields)
					params.fields = fields

				if (custom_page_limit)
					params.custom_page_limit = custom_page_limit

				vm.getJSON("Job/get",params).then(response => {
					vm.$store.projects = response.data

					resolve(response)
				})
			})
		},
		fetchServices(include,filters,fields,page,custom_page_limit) {
			let vm = this

			return new Promise((resolve,reject) => {
				
				let params = {}

				if (include)
					params.include = include

				if (filters)
					params.filters = filters

				if (fields)
					params.fields = fields

				if (custom_page_limit)
					params.custom_page_limit = custom_page_limit

				if (page) {
					params.page = page

					vm.getJSON("Service/get",params).then(response => {
						vm.$store.services = response.data

						resolve(response)
					})
				}
				else {
					params.page = 1

					let combinedResults = []

					//iterate through all pages, and then merge the responses
					vm.getJSON("Service/get",params).then(response => {
						combinedResults = response

						let promises = []
						if (response.success && "meta" in response && "num_pages" in response.meta) {
							
							let numPages = response.meta.num_pages

							for (var p = 2; p <= numPages; p++) {
								params.page = p

								promises.push(vm.getJSON("Service/get",params))
							}

							Promise.all(promises).then(responses => {

								responses.forEach(pageResponse => {
									combinedResults.data = [
										...combinedResults.data,
										...pageResponse.data
									]
								})

								vm.$store.services = combinedResults.data

								resolve(combinedResults)
							})
						}
						else
							resolve(combinedResults)
					})
				}

				
			})
		},
		fetchServiceStatuses() {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("Service/statuses").then(response => {
					if (response.success) {
						vm.$store.serviceStatuses = response.data
					}

					resolve(response)
				})
			})
		},
		serviceStatusOptions(type) {
			let vm = this

			let statuses = this.$store.serviceStatuses
			if (type) {
				statuses = statuses.filter(status => {
					if (status.type == type)
						return true
				})
			}

			return this.optionify(statuses,"label")
		},
		fetchUsers(filters,resultStore,fields,include) {
			let vm = this

			let filterQuery = ""

			let params = {}

			if (filters)
				params.filters = filters
			
			if (fields)
				params.fields = fields

			if (include)
				params.include = include

			return new Promise((resolve,reject) => {
				vm.getJSON("User/get",params).then(response => {

					if (resultStore)
						vm[resultStore] = response.data
					else
						vm.$store.users = response.data

					resolve(response)
				})
			})
		},
		fetchExpenseCodes(include,filters) {
			let vm = this

			if (!include)
				include = ["ExpenseGroup"] //include expense group by default

			let params = {
				include
			}

			if (filters)
				params.filters = filters

			return new Promise((resolve,reject) => {
				vm.getJSON("ExpenseCode/get",params).then(response => {
					vm.$store.expenseCodes = response.data

					resolve(response)
				})
			})
		},
		fetchContactIndividuals(filters,limit) {
			let vm = this

			let params = {
				include: ["Contact"]
			}

			if (!filters) 
				params.filters = [["is_company",0]]
			else
				params.filters = filters

			if (limit)
				params.limit = limit

			return new Promise((resolve,reject) => {
				vm.getJSON("Contact/get",params).then(response => {
					vm.$store.contactsIndividuals = response.data

					resolve(response)
				})
			})
		},
		fetchJobCategories() {
			let vm = this

			const params = {
				include: [
					{ model: 'FormChildTemplate', fields: ['id'] },
					{ model: 'Checklist', fields: ['id'] }
				]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("Category/get", params).then(response => {

					vm.$store.categories = response.data

					resolve(response)
				})
			})
		},
		fetchRevenueCodes() {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("RevenueCode/get",{}).then(response => {

					vm.$store.revenueCodes = response.data

					resolve(response)
				})
			})
		},
		fetchUnions(includeArchivedCAs) {
			let vm = this

			let caFilters = []
			if (!includeArchivedCAs)
				caFilters = [['archived',0]]

			let params = {
				include: [{
					model:"CollectiveAgreement",
					filters: caFilters,
					include: [
						{model: "User",fields: ["id","slug","first_name","last_name"]}
					]
				}]
			}

			return new Promise((resolve, reject) => {
				vm.getJSON("Union/get",params).then(response => {
					vm.$store.unions = response.data

					resolve(response)
				})
			})
		},
		userOptions(removeSelf,storeLocation) {
			let vm = this

			let users = this.$store.users
			if (storeLocation)
				users = storeLocation

			let userOptions = []
			if (users) {
				userOptions = this.optionify(users.map(user => {

					user.fullName = user.first_name+ " "+ user.last_name

					return user

				}),"fullName")
			}

			if (removeSelf) {
				userOptions = userOptions.filter(user => {
					if (user.value != vm.$store.userDetails.id)
						return true
				})
			}

			return userOptions
		},
		collectiveAgreementOptions(union_id) {
			let cas = []

			this.$store.unions.forEach(union => {
				if (union.id == union_id)
					cas = JSON.parse(JSON.stringify(union.CollectiveAgreement))
			})

			cas = cas.map(ca => {
				if (ca.is_default == 1)
					ca.title += " (default)"

				return ca
			})

			if (cas)
				return this.optionify(cas,"title");
			else
				return []
		},
		fetchJobPersonnelRoles(fields) {
			let vm = this

			let params
			if (fields) {
				params = {
					fields
				}
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("JobPersonnelRole/get",params).then(response => {
					if (response.success)
						vm.$store.jobPersonnelRoles = response.data

					resolve(response)
				})
			})
		},
		fetchUserRoles(userId,jobType,jobId,includes) {
			let vm = this

			let jobKey, resource
			if (jobType == 'project') {
				jobKey = "job_id"
				resource = "JobUser"
			}
			else {
				jobKey = "service_id"
				resource = "ServiceUser"
			}

			return new Promise((resolve,reject) => {

				let filters = [
					[jobKey,jobId],
					["user_id",userId]
				]

				let params = {
					filters,
					include: includes
				}

				this.getJSON(resource+"/get",params).then(response => {
					resolve(response)
				})
				
			})
		},
		fetchProfileImages(threadsWithMembers) {
			let vm = this

			//fetch user avatars
			let imageIdList = []

			if (threadsWithMembers) {
				threadsWithMembers.forEach(thread => {
					if ("Members" in thread && thread.Members) {
						thread.Members.forEach(member => {
							if (member.image_id > 0)
								imageIdList.push(parseInt(member.image_id))
						})
					}
				})
			}

			let params = {
				filters: [["id",imageIdList]],
				fields: ["filename","height","width","slug"]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("ProfileImage/get",params).then(images => {
					resolve(images.data)
				})
			})
		},
		fetchCompanyData(spinner,include) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let params = {}
			if (include) 
				params.include = include

			return new Promise((resolve,reject) => {

				vm.getJSON("Company/mine",params).then(response => {

					if (spinner)
						vm.spinner(false)

					if (response.success) {

						vm.$set(vm.$store,"company",response.data)
						vm.$set(vm.$store.company,"CompanySetting",response.data.CompanySetting)

						if (vm.$store.company.setup_finished == 0 && vm.$store.userDetails.id == vm.$store.company.managing_user_id) {
							vm.$store.companySetupMode = true

							let lastStep = ""
							if (vm.$store.company.last_setup_step > 0)
								lastStep = vm.$store.company.last_setup_step

							vm.$router.push("/setup/"+lastStep)
						}

						if (response.data.ProfileImage)
							vm.$store.companyImageUrl = vm.$root.apiRoot+'resources/profile-images/'+response.data.ProfileImage.slug+'/'+response.data.ProfileImage.filename
					}

					resolve(response)
				})
			})
		},
		fetchNotifications(spinner,limit,includeDismissed) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let params = {}

			if (limit)
				params.limit = limit

			if (!includeDismissed) {
				params.filters = [
					["is_dismissed",0]
				]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("Notification/get",params).then(response => {
					if (spinner)
						vm.spinner(false)

					if (response.success)
						//update recentNotifications for top menu
						vm.$store.recentNotifications = response.data.filter(noti => noti.is_dismissed == 0).slice(0,vm.$store.maxRecentNotifications)
					resolve(response)
				})

			})
		},
		fetchQBOResource(resource,where,spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let payload = {
				resource
			}

			if (where)
				payload.where = where

			return new Promise((resolve,reject) => {

				vm.getJSON("QuickbooksConnection/get-resource",payload).then(response => {
					if (spinner)
						vm.spinner(false)

					resolve(response)
				})

			})
		},
		fetchQBOCreditCardAccountsUserSettings() {
			let vm = this

			return new Promise((resolve,reject) => {

				vm.getJSON("QuickbooksConnection/get",{}).then(response => {
					if (response.success && response.data.length > 0) {
						vm.$store.qboUserCreditCardSettings = []

						try {
							vm.$store.qboUserCreditCardSettings = JSON.parse(response.data[0].credit_card_owners_json)
						}
						catch (e) {}
					}
					resolve(response)
				})

			})
		},
		fetchQboTaxCodes(suppressError) {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("QuickbooksConnection/get-resource",{resource: 'TaxCode'},!suppressError).then(response => {
					resolve(response)
				})
			})
		},
		//fetches a list of services and projects that are related to the user
		fetchMyJobs() {
			let vm = this

			let promises = []

			promises.push(this.getJSON("Job/get",{
				filters: [
					["User.id",this.$store.userDetails.id],
					["archived",0]
				],
				include: [
					{
						model: "User",
						fields: ["id","slug"]
					}
				],
				felds: ["id","slug"]
			}))

			promises.push(this.getJSON("Service/my-list",{
				fields: ["id","slug"]
			}))

			Promise.all(promises).then(responses => {
				if (responses[0].success)
					vm.$store.userProjectIds = responses[0].data.map(job => job.id)
				if (responses[1].success)
					vm.$store.userServiceIds = responses[1].data.map(job => job.id)
			})
		},
		fetchMeasurementUnits() {
			let vm = this

			return new Promise((resolve,reject) => {

				vm.getJSON("Material/units").then(response => {
					if (response.success)
						vm.$store.unitMeasurementOptions = response.data

					resolve(response)
				})
			})
		},	
		registerEngagementClick(ad_location_key) {
			this.postData("Engagement/record-action",{ad_location_key})
		}
	},
	computed: {
		ccAccountOptions() {
			let vm = this

			let filteredOptions = this.$store.qboCreditCardAccounts.filter(account => {

				let theAccount = vm.$store.qboUserCreditCardSettings.find(setting => setting.qbo_account_id == account.Id)

				if (theAccount && "userIds" in theAccount && theAccount.userIds && theAccount.userIds.length > 0) {
					if (theAccount.userIds.indexOf(vm.$store.userDetails.id) >= 0)
						return true
					else
						return false
				}
		
				return true

			}).map(account => {
				return {
					value: account.Id,
					text: account.Name+": "+account.Description
				}
			})

			return filteredOptions
		},
		jobOptions() {
			let projects
			if ("projects" in this)
				projects = this.projects
			else if (this.$store.projects) {
				projects = this.$store.projects
			}

			if (projects) {
				return this.optionify(projects.map(job => {
					job.jobNumberAndName = job.job_num +" : " + job.job_name

					return job
				}),"jobNumberAndName")
			}

			return []
		},
		serviceOptions() {
			let services 

			if ("services" in this)
				services = this.services
			else if (this.$store.services)
				services = this.$store.services

			if (services) {
				return this.optionify(services.map(service => {
					service.label = service.job_num// + ": " + service.job_name

					if ("customer_name_cache" in service)
						service.label += ": " + service.customer_name_cache
					else if ("Customer" in service && service.Customer)
						service.label += ": "+service.Customer.name
					else if ("job_name" in service && service.job_name)
						service.label += ": "+service.job_name

					return service
				}),"label")
			}

			return []
		},
		expenseGroupOptions() {
			if (this.$store.expenseGroups)
				return this.optionify(this.$store.expenseGroups,"group_name")

			return []
		},
		categoryOptions() {
			return this.optionify(this.$store.categories,"name")
		},
		revenueCodeOptions() {
			if (this.$store.revenueCodes) {
				return this.optionify(this.$store.revenueCodes.map(code => {
					code.displayName = code.code + ": " + code.description

					return code
				}),"displayName")
			}
			return []
		},
		contactsIndividualsOptions() {
			if (this.$store.contactsIndividuals) {
				return this.optionify(this.$store.contactsIndividuals.map(contact => {

					contact.nameAndCompany = contact.name

					if ("Company" in contact && contact.Company) 
						contact.nameAndCompany += ", " + contact.Company.name

					return contact
				}), "nameAndCompany")
			}
			return []
		},
		equipmentOptions() {
			if (this.$store.equipments) {
				return this.optionify(this.$store.equipments.map(eq => {
					if ("EquipmentType" in eq && eq.EquipmentType && "name" in eq.EquipmentType)
						eq.formattedDescription = eq.description + " (" + eq.EquipmentType.name + ")"

					else
						eq.formattedDescription = eq.description

					return eq
				}),"formattedDescription")
			}
			return []
		},
		equipmentTypeOptions() {
			if (this.$store.equipmentTypes)
				return this.optionify(this.$store.equipmentTypes,"name")
			return []
		}
	}
}